import React from 'react';

// Composant EnvironmentSection déplacé à l'extérieur pour éviter les re-renders
const EnvironmentSection = React.memo(({ env, title, bgColor, data, updateArchitecture, addServeur, updateServeur, removeServeur }) => (
  <div className={`border border-gray-200 rounded-lg p-6 ${bgColor}`}>
    <h3 className="text-lg font-semibold mb-4">{title}</h3>
    
    {/* Type d'architecture */}
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Type d'architecture
      </label>
      <select
        value={data[env]?.type || 'onpremise'}
        onChange={(e) => updateArchitecture(env, 'type', null, e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option value="onpremise">On-Premise</option>
        <option value="cloud">Cloud (HDS)</option>
        <option value="hybride">Hybride</option>
      </select>
    </div>

    {/* Serveurs */}
    <div className="mb-6">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium text-gray-700">Serveurs</h4>
        <button
          onClick={() => addServeur(env)}
          className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
        >
          + Ajouter un serveur
        </button>
      </div>
      
      {data[env]?.serveurs && data[env].serveurs.length > 0 ? (
        <div className="space-y-3">
          {data[env].serveurs.map((serveur, index) => (
            <div key={serveur.id || index} className="border border-gray-200 rounded p-4 bg-white">
              <div className="flex justify-between items-start mb-3">
                <h5 className="font-medium">Serveur {index + 1}</h5>
                <button
                  onClick={() => removeServeur(env, index)}
                  className="text-red-600 hover:text-red-800"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Nom</label>
                  <input
                    type="text"
                    value={serveur.nom || ''}
                    onChange={(e) => updateServeur(env, index, 'nom', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Rôle</label>
                  <input
                    type="text"
                    value={serveur.role || ''}
                    onChange={(e) => updateServeur(env, index, 'role', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">OS</label>
                  <input
                    type="text"
                    value={serveur.os || ''}
                    onChange={(e) => updateServeur(env, index, 'os', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">IP</label>
                  <input
                    type="text"
                    value={serveur.ip || ''}
                    onChange={(e) => updateServeur(env, index, 'ip', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">CPU</label>
                  <input
                    type="text"
                    value={serveur.cpu || ''}
                    onChange={(e) => updateServeur(env, index, 'cpu', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">RAM</label>
                  <input
                    type="text"
                    value={serveur.ram || ''}
                    onChange={(e) => updateServeur(env, index, 'ram', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Stockage</label>
                  <input
                    type="text"
                    value={serveur.stockage || ''}
                    onChange={(e) => updateServeur(env, index, 'stockage', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-600 mb-1">Notes</label>
                  <input
                    type="text"
                    value={serveur.notes || ''}
                    onChange={(e) => updateServeur(env, index, 'notes', e.target.value)}
                    className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500 text-center py-4 bg-gray-50 rounded">
          Aucun serveur configuré
        </p>
      )}
    </div>

    {/* Infrastructure */}
    <div>
      <h4 className="font-medium text-gray-700 mb-3">Infrastructure</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm text-gray-600 mb-1">Virtualisation</label>
          <input
            type="text"
            value={data[env]?.infrastructure?.virtualisation || ''}
            onChange={(e) => updateArchitecture(env, 'infrastructure', 'virtualisation', e.target.value)}
            placeholder="VMware, Hyper-V, etc."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Stockage</label>
          <input
            type="text"
            value={data[env]?.infrastructure?.stockage || ''}
            onChange={(e) => updateArchitecture(env, 'infrastructure', 'stockage', e.target.value)}
            placeholder="SAN, NAS, local..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Sauvegarde</label>
          <input
            type="text"
            value={data[env]?.infrastructure?.sauvegarde || ''}
            onChange={(e) => updateArchitecture(env, 'infrastructure', 'sauvegarde', e.target.value)}
            placeholder="Solution et fréquence"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm text-gray-600 mb-1">Monitoring</label>
          <input
            type="text"
            value={data[env]?.infrastructure?.monitoring || ''}
            onChange={(e) => updateArchitecture(env, 'infrastructure', 'monitoring', e.target.value)}
            placeholder="Outils de supervision"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
    </div>
  </div>
));

export const ArchitectureTab = ({ data, setData }) => {
  const updateArchitecture = React.useCallback((env, section, field, value) => {
    setData(prev => ({
      ...prev,
      architecture: {
        ...prev.architecture,
        [env]: {
          ...prev.architecture?.[env],
          [section]: section === 'infrastructure' ? {
            ...prev.architecture?.[env]?.[section],
            [field]: value
          } : value
        }
      }
    }));
  }, [setData]);

  const addServeur = React.useCallback((env) => {
    setData(prev => ({
      ...prev,
      architecture: {
        ...prev.architecture,
        [env]: {
          ...prev.architecture?.[env],
          serveurs: [...(prev.architecture?.[env]?.serveurs || []), {
            id: Date.now(),
            nom: '',
            role: '',
            os: '',
            cpu: '',
            ram: '',
            stockage: '',
            ip: '',
            notes: ''
          }]
        }
      }
    }));
  }, [setData]);

  const updateServeur = React.useCallback((env, index, field, value) => {
    setData(prev => {
      const updatedServeurs = [...(prev.architecture?.[env]?.serveurs || [])];
      updatedServeurs[index] = {
        ...updatedServeurs[index],
        [field]: value
      };
      return {
        ...prev,
        architecture: {
          ...prev.architecture,
          [env]: {
            ...prev.architecture?.[env],
            serveurs: updatedServeurs
          }
        }
      };
    });
  }, [setData]);

  const removeServeur = React.useCallback((env, index) => {
    setData(prev => ({
      ...prev,
      architecture: {
        ...prev.architecture,
        [env]: {
          ...prev.architecture?.[env],
          serveurs: (prev.architecture?.[env]?.serveurs || []).filter((_, i) => i !== index)
        }
      }
    }));
  }, [setData]);

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Architecture des Environnements</h2>
      
      {/* Production */}
      <EnvironmentSection 
        env="production" 
        title="Architecture PRODUCTION" 
        bgColor="bg-red-50"
        data={data}
        updateArchitecture={updateArchitecture}
        addServeur={addServeur}
        updateServeur={updateServeur}
        removeServeur={removeServeur}
      />

      {/* Qualification */}
      <EnvironmentSection 
        env="qualification" 
        title="Architecture QUALIFICATION" 
        bgColor="bg-blue-50"
        data={data}
        updateArchitecture={updateArchitecture}
        addServeur={addServeur}
        updateServeur={updateServeur}
        removeServeur={removeServeur}
      />

      {/* Templates disponibles */}
      <div className="mt-8 bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h4 className="font-semibold text-gray-800 mb-3">Templates disponibles :</h4>
        <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
          <li>Template Architecture On-Premise standard</li>
          <li>Template Architecture HDS (Hébergement de Données de Santé)</li>
          <li>Configuration type pour environnement de production</li>
          <li>Configuration type pour environnement de qualification</li>
        </ul>
      </div>
    </div>
  );
};